import {Action} from '@ngrx/store';
import {WikiGroup, WikiGroupOrder, WikiItem, WikiItemOrder} from './../../../wiki/models/wiki.model';

export enum WikiActionType {
  GET_ALL = '[Wiki] Get All',
  GET_ALL_SUCCESS = '[Wiki] Get All Success',
  CREATE_WIKI_GROUP = '[Wiki] Create',
  CREATE_WIKI_GROUP_SUCCESS = '[Wiki] Create Success',
  UPDATE_WIKI_GROUP = '[Wiki] Update',
  UPDATE_WIKI_GROUP_SUCCESS = '[Wiki] Update Success',
  DELETE_WIKI_GROUP = '[Wiki] Delete',
  DELETE_WIKI_GROUP_SUCCESS = '[Wiki] Delete Success',
  CREATE_WIKI_ITEM = '[Wiki] Create Item',
  CREATE_WIKI_ITEM_SUCCESS = '[Wiki] Create Item Success',
  UPDATE_WIKI_ITEM = '[Wiki] Update Item',
  UPDATE_WIKI_ITEM_SUCCESS = '[Wiki] Update Item Success',
  DELETE_WIKI_ITEM = '[Wiki] Delete Item',
  DELETE_WIKI_ITEM_SUCCESS = '[Wiki] Delete Item Success',
  UPDATE_WIKI_GROUP_ORDER = '[Wiki] Update Groups Order',
  UPDATE_WIKI_GROUP_ORDER_SUCCESS = '[Wiki] Update Groups Order Success',
  UPDATE_WIKI_ITEM_ORDER = '[Wiki] Update Item Order',
  UPDATE_WIKI_ITEM_ORDER_SUCCESS = '[Wiki] Update Item Order Success',
  GET_WIKI_ITEM = '[Wiki] Get Wiki Item',
  GET_WIKI_ITEM_SUCCESS = '[Wiki] Get Wiki Item Success',
}

export class GetAllWikiGroupsAction implements Action {
  readonly type = WikiActionType.GET_ALL;
  constructor(public payload: {onSuccess?: () => void; onFailure?: (error: string) => void}) {}
}

export class GetAllWikiGroupsSuccessAction implements Action {
  readonly type = WikiActionType.GET_ALL_SUCCESS;
  constructor(public payload: {wikiList: WikiGroup[]}) {}
}

export class CreateWikiGroupAction implements Action {
  readonly type = WikiActionType.CREATE_WIKI_GROUP;
  constructor(public payload: {wikiGroup: WikiGroup; onSuccess?: () => void; onFailure?: (error: string) => void}) {}
}

export class CreateWikiGroupSuccessAction implements Action {
  readonly type = WikiActionType.CREATE_WIKI_GROUP_SUCCESS;
  constructor(public payload: {wikiGroup: WikiGroup}) {}
}

export class UpdateWikiGroupAction implements Action {
  readonly type = WikiActionType.UPDATE_WIKI_GROUP;
  constructor(public payload: {wikiGroup: WikiGroup; onSuccess?: () => void; onFailure?: (error: string) => void}) {}
}

export class UpdateWikiGroupSuccessAction implements Action {
  readonly type = WikiActionType.UPDATE_WIKI_GROUP_SUCCESS;
  constructor(public payload: {wikiGroup: WikiGroup}) {}
}

export class DeleteWikiGroupAction implements Action {
  readonly type = WikiActionType.DELETE_WIKI_GROUP;
  constructor(public payload: {id: string; onSuccess?: () => void; onFailure?: (error: string) => void}) {}
}

export class DeleteWikiGroupSuccessAction implements Action {
  readonly type = WikiActionType.DELETE_WIKI_GROUP_SUCCESS;
  constructor(public payload: {id: string}) {}
}

export class CreateWikiItemAction implements Action {
  readonly type = WikiActionType.CREATE_WIKI_ITEM;
  constructor(public payload: {wikiItem: WikiItem; onSuccess?: () => void; onFailure?: (error: string) => void}) {}
}

export class CreateWikiItemSuccessAction implements Action {
  readonly type = WikiActionType.CREATE_WIKI_ITEM_SUCCESS;
  constructor(public payload: {wikiItem: WikiItem}) {}
}

export class UpdateWikiItemAction implements Action {
  readonly type = WikiActionType.UPDATE_WIKI_ITEM;
  constructor(public payload: {wikiItem: WikiItem; onSuccess?: () => void; onFailure?: (error: string) => void}) {}
}

export class UpdateWikiItemSuccessAction implements Action {
  readonly type = WikiActionType.UPDATE_WIKI_ITEM_SUCCESS;
  constructor(public payload: {wikiItem: WikiItem}) {}
}

export class DeleteWikiItemAction implements Action {
  readonly type = WikiActionType.DELETE_WIKI_ITEM;
  constructor(public payload: {wikiItem: WikiItem; onSuccess?: () => void; onFailure?: (error: string) => void}) {}
}

export class DeleteWikiItemSuccessAction implements Action {
  readonly type = WikiActionType.DELETE_WIKI_ITEM_SUCCESS;
  constructor(public payload: {id: string}) {}
}

export class UpdateWikiGroupsOrderAction implements Action {
  readonly type = WikiActionType.UPDATE_WIKI_GROUP_ORDER;
  constructor(
    public payload: {wikiGroupOrder: WikiGroupOrder; onSuccess?: () => void; onFailure?: (error: string) => void}
  ) {}
}

export class UpdateWikiGroupsOrderSuccessAction implements Action {
  readonly type = WikiActionType.UPDATE_WIKI_GROUP_ORDER_SUCCESS;
  constructor(public payload: string) {}
}

export class UpdateWikiItemOrderAction implements Action {
  readonly type = WikiActionType.UPDATE_WIKI_ITEM_ORDER;
  constructor(
    public payload: {wikiItemOrder: WikiItemOrder; onSuccess?: () => void; onFailure?: (error: string) => void}
  ) {}
}
export class UpdateWikiItemOrderSuccessAction implements Action {
  readonly type = WikiActionType.UPDATE_WIKI_ITEM_ORDER_SUCCESS;
  constructor(public payload: string) {}
}

export class GetWikiItemAction implements Action {
  readonly type = WikiActionType.GET_WIKI_ITEM;
  constructor(public payload: {itemId: string; onSuccess?: () => void; onFailure?: (error: string) => void}) {}
}

export class GetWikiItemSuccessAction implements Action {
  readonly type = WikiActionType.GET_WIKI_ITEM_SUCCESS;
  constructor(public payload: {wikiItem: WikiItem}) {}
}

export type WikiAction =
  | GetAllWikiGroupsAction
  | GetAllWikiGroupsSuccessAction
  | CreateWikiGroupAction
  | CreateWikiGroupSuccessAction
  | UpdateWikiGroupAction
  | UpdateWikiGroupSuccessAction
  | DeleteWikiGroupAction
  | DeleteWikiGroupSuccessAction
  | CreateWikiItemAction
  | CreateWikiItemSuccessAction
  | UpdateWikiItemAction
  | UpdateWikiItemSuccessAction
  | DeleteWikiItemAction
  | DeleteWikiItemSuccessAction
  | UpdateWikiGroupsOrderAction
  | UpdateWikiGroupsOrderSuccessAction
  | UpdateWikiItemOrderAction
  | UpdateWikiItemOrderSuccessAction
  | GetWikiItemAction
  | GetWikiItemSuccessAction;
